function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { isKeyframesTarget } from '../animation/utils/is-keyframes-target.mjs';
var isCustomValue = function isCustomValue(v) {
  return Boolean(v && _typeof(v) === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function resolveFinalValueInKeyframes(v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};
export { isCustomValue, resolveFinalValueInKeyframes };